module.exports = __webpack_public_path__ + "01_glasses_red.b3357034.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer4/01_glasses_red.png
// module id = 0WoF
// module chunks = 0